import { ProveedorEstado } from 'src/utils/enums/ProveedorEstado';
import { ProveedorFormState } from './types';
import {
  verificarProveedorF,
  rechazarProveedorF,
  marcarConReservaProveedorF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';
import { colorMapping } from 'src/utils/enums/ProveedorEstado';

const initialState: ProveedorFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'proveedorForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: ProveedorEstado.Borrador,
        text: ProveedorEstado[ProveedorEstado.Borrador].toUpperCase(),
        color: colorMapping[ProveedorEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        verificarProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar al proveedor',
        },
        rechazarProveedorF: {
          visible: true,
          disabled: true,
          tooltip: 'Rechazar al proveedor',
        },
        marcarConReservaProveedorF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar con reserva al proveedor',
        },
      };
    },

    setFormStatusVerificado(state) {
      state.status = {
        id: ProveedorEstado.Verificado,
        text: ProveedorEstado[ProveedorEstado.Verificado].toUpperCase(),
        color: colorMapping[ProveedorEstado.Verificado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarProveedorF: {
          visible: false,
          disabled: false,
          tooltip: 'Validar al proveedor',
        },
        rechazarProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Rechazar al proveedor',
        },
        marcarConReservaProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar con reserva al proveedor',
        },
      };
    },
    setFormStatusRechazado(state) {
      state.status = {
        id: ProveedorEstado.Rechazado,
        text: ProveedorEstado[ProveedorEstado.Rechazado].toUpperCase(),
        color: colorMapping[ProveedorEstado.Rechazado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Validar al proveedor',
        },
        rechazarProveedorF: {
          visible: false,
          disabled: false,
          tooltip: 'Rechazar al proveedor',
        },
        marcarConReservaProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar con reserva al proveedor',
        },
      };
    },
    setFormStatusConReserva(state) {
      state.status = {
        id: ProveedorEstado.ConReserva,
        text: ProveedorEstado[ProveedorEstado.ConReserva].toUpperCase(),
        color: colorMapping[ProveedorEstado.ConReserva],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Validar al proveedor',
        },
        rechazarProveedorF: {
          visible: true,
          disabled: false,
          tooltip: 'Rechazar al proveedor',
        },
        marcarConReservaProveedorF: {
          visible: false,
          disabled: false,
          tooltip: 'Marcar con reserva al proveedor',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verificarProveedorF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(verificarProveedorF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(rechazarProveedorF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(rechazarProveedorF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarConReservaProveedorF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarConReservaProveedorF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.proveedor.form.status;

export const selectVerificarProveedorF = (state: RootState) =>
  state.proveedor.form.actions?.verificarProveedorF;

export const selectRechazarProveedorF = (state: RootState) =>
  state.proveedor.form.actions?.rechazarProveedorF;

export const selectMarcarConReservaProveedorF = (state: RootState) =>
  state.proveedor.form.actions?.marcarConReservaProveedorF;

export const selectGuardar = (state: RootState) =>
  state.proveedor.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusVerificado,
  setFormStatusRechazado,
  setFormStatusConReserva,
} = formSlice.actions;

export default formSlice.reducer;
